module.exports = __webpack_public_path__ + "img/CM-BS-24-BMW-Established.8398b717.jpg";